module.exports = __webpack_public_path__ + "img/avatar-32.ea86cb22.png";